import { createReducer } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';

import { REGISTRATIONS_DETAIL_RESET } from './registrationsDetail.const';
import registrationsInfoReducer from './registrationsInfo/registrationsInfo.reducer';

export const initialState = {};

const combinedReducers = combineReducers({
  info: registrationsInfoReducer,
});

const registrationsDetailReducer = createReducer(initialState, builder => {
  builder.addCase(REGISTRATIONS_DETAIL_RESET, () => initialState).addDefaultCase(() => {});
});

export default (state = initialState, action) => {
  const newState = registrationsDetailReducer(state, action);
  return combinedReducers(newState, action);
};
